import { FEATURE_FLAGS } from "./featureFlags"

const LOCAL_STORAGE_KEY = 'ls_key'
const QUERY_PARAM_KEY = 'ff'
const url = new URL(window.location.href.toString())

const getFlagsFromLocalStorage = () => {
  const flag = localStorage.getItem(LOCAL_STORAGE_KEY)
  if (flag) {
    return JSON.parse(flag)
  }
  return {}
}

const getFlagState = (param: string) => {
  const ffParams = url.searchParams.get(QUERY_PARAM_KEY)
  return (
    (ffParams && ffParams.indexOf(param) >= 0)
    || getFlagsFromLocalStorage()[param]
    || false
  )
}

type FeatureFlagKey = (typeof FEATURE_FLAGS)[number]['key']

const featureFlags = Object.fromEntries(
  FEATURE_FLAGS.map(feature => [feature.key, getFlagState(feature.key)])
) as { [K in FeatureFlagKey]: boolean }

const featureFlagDescriptions = Object.fromEntries(
  FEATURE_FLAGS.map(feature => [feature.key, feature.desc])
) as { [K in FeatureFlagKey]: string }

export {
  LOCAL_STORAGE_KEY,
  getFlagsFromLocalStorage,
  featureFlags,
  featureFlagDescriptions,
}